/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AppointmentMeetingProposalComponent = {
  id?: number
  initiator?: AppointmentMeetingProposalComponent.initiator
  options?: Array<{
    id?: number
    date?: string
    location?: string
    url?: string
    address?: string
    meetingWith?: string
    type?: 'videocall' | 'phone' | 'location'
  }>
}
export namespace AppointmentMeetingProposalComponent {
  export enum initiator {
    COMPANY = 'company',
    PROFESSIONAL = 'professional',
    VACANCY = 'vacancy',
  }
}
